<template>
    <LoadingComponent :props="loading"/>

    <div class="db-card db-tab-div active">
        <div class="db-card-header border-none">
            <h3 class="db-card-title">{{ $t("menu.outlets") }}</h3>
            <div class="db-card-filter">
                <TableLimitComponent :method="list" :search="props.search" :page="paginationPage"/>
                <FilterComponent v-if="paginationPage && paginationPage.total > Number(props.search.per_page || 10)" :page="pagination" :search="props.search" @click.prevent="handleSlide('outlet-filter')"/>
                <OutletCreateComponent :props="props"/>
            
                <button
                    type="button"
                    class="db-btn h-[37px] py-2 px-3 text-white bg-primary ml-2"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button></div>
        </div>

        <div v-if="paginationPage && paginationPage.total > Number(props.search.per_page || 10)" class="table-filter-div" id="outlet-filter">
            <form class="p-4 sm:p-5 border-t" @submit.prevent="search">
                <div class="row pt-2">
                    <div class="col-12 sm:col-6 md:col-4 xl:col-3 !pt-0">
                        <label for="searchOutletName" class="db-field-title after:hidden">{{ $t("label.name") }}</label>
                        <input id="searchOutletName" v-model="props.search.name" type="text" class="db-field-control"/>
                    </div>

                    <div class="col-12 sm:col-6 md:col-4 xl:col-3 !pt-0">
                        <label for="searchOutletStatus" class="db-field-title after:hidden">{{ $t("label.status") }}</label>
                        <vue-select class="db-field-control f-b-custom-select" id="searchOutletStatus"
                                    v-model="props.search.status" :options="[
                                { id: enums.statusEnum.ACTIVE, name: $t('label.active') },
                                { id: enums.statusEnum.INACTIVE, name: $t('label.inactive') },
                            ]" label-by="name" value-by="id" :closeOnSelect="true" :searchable="true"
                                    :clearOnClose="true" placeholder="--" search-placeholder="--"/>
                    </div>

                    <div class="col-12 border-t mt-1">
                        <div class="flex flex-wrap justify-end gap-2">
                            <button class="db-btn py-2 px-3 bg-gray-200" @click.prevent="handleSlide('outlet-filter')">
                                <i class="lab lab-fill-close"></i>
                            </button>
                            <button class="db-btn py-2 bg-gray-200" @click="clear">
                                <span>{{ $t('button.restore') }}</span>
                            </button>
                            <button class="db-btn py-2 text-white bg-primary">
                                <span>{{ $t('button.apply_filter') }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="db-table-responsive">
            <table class="db-table stripe">
                <thead class="db-table-head">
                <tr class="db-table-head-tr">
                    <th class="db-table-head-th">{{ $t("label.name") }}</th>
                    <th class="db-table-head-th">
                        {{ $t("label.status") }}
                    </th>
                    <th class="db-table-head-th text-right">
                        {{ $t("label.action") }}
                    </th>
                </tr>
                </thead>
                <tbody class="db-table-body" v-if="outlets.length > 0">
                <tr class="db-table-body-tr" v-for="outlet in outlets" :key="outlet">
                    <td class="db-table-body-td" v-if="site_default_outlet === outlet.id">
                        {{ outlet.name }}({{ $t('label.default') }})
                    </td>
                    <td class="db-table-body-td" v-else>
                        {{ outlet.name }}
                    </td>
                    <td class="db-table-body-td">
                            <span :class="statusClass(outlet.status)">
                                {{ enums.statusEnumArray[outlet.status] }}
                            </span>
                    </td>
                    <td class="db-table-body-td">
                        <div class="flex justify-end items-center sm:items-start sm:justify-end gap-1.5">
                            <SmViewComponent :link="'admin.settings.outlet.show'" :id="outlet.id"/>
                            <SmModalEditComponent @click="edit(outlet)"/>
                            <SmDeleteComponent @click="destroy(outlet.id)" v-if="site_default_outlet !== outlet.id"/>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-6">
            <PaginationSMBox :pagination="pagination" :method="list"/>
            <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                <PaginationTextComponent :props="{ page: paginationPage }"/>
                <PaginationBox :pagination="pagination" :method="list"/>
            </div>
        </div>
    </div>
</template>
<script>
import LoadingComponent from "../../components/LoadingComponent";
import OutletCreateComponent from "./OutletCreateComponent";
import alertService from "../../../../services/alertService";
import PaginationTextComponent from "../../components/pagination/PaginationTextComponent";
import PaginationBox from "../../components/pagination/PaginationBox";
import PaginationSMBox from "../../components/pagination/PaginationSMBox";
import appService from "../../../../services/appService";
import statusEnum from "../../../../enums/modules/statusEnum";
import TableLimitComponent from "../../components/TableLimitComponent";
import SmDeleteComponent from "../../components/buttons/SmDeleteComponent";
import SmModalEditComponent from "../../components/buttons/SmModalEditComponent";
import SmViewComponent from "../../components/buttons/SmViewComponent";
import FilterComponent from "../../components/buttons/collapse/FilterComponent";

export default {
    name: "OutletListComponent",
    components: {
        TableLimitComponent,
        PaginationSMBox,
        PaginationBox,
        PaginationTextComponent,
        OutletCreateComponent,
        LoadingComponent,
        SmDeleteComponent,
        SmModalEditComponent,
        SmViewComponent,
        FilterComponent,
    },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false,
            },
            enums: {
                statusEnum: statusEnum,
                statusEnumArray: {
                    [statusEnum.ACTIVE]: this.$t("label.active"),
                    [statusEnum.INACTIVE]: this.$t("label.inactive"),
                },
            },
            props: {
                form: {
                    name: "",
                    email: "",
                    country_code: "",
                    phone: "",
                    latitude: "",
                    longitude: "",
                    city: "",
                    state: "",
                    zip_code: "",
                    address: "",
                    status: statusEnum.ACTIVE,
                },
                search: {
                    paginate: 1,
                    page: 1,
                    per_page: 10,
                    order_column: "id",
                    order_type: "desc",
                    name: "",
                    status: null,
                },
            },
            site_default_outlet: null,
        };
    },
    mounted() {
        this.list();
        this.siteList();
    },
    computed: {
        outlets: function () {
            return this.$store.getters["outlet/lists"];
        },
        pagination: function () {
            return this.$store.getters["outlet/pagination"];
        },
        paginationPage: function () {
            return this.$store.getters["outlet/page"];
        },
    },
    methods: {
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.list().then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
            }).catch(() => {
                this.isRefreshingView = false;
            });
        },
        statusClass: function (status) {
            return appService.statusClass(status);
        },
        textShortener: function (text, number = 30) {
            return appService.textShortener(text, number);
        },
        handleSlide: function (id) {
            return appService.handleSlide(id);
        },
        search: function () {
            this.list();
        },
        clear: function () {
            this.props.search.paginate = 1;
            this.props.search.page = 1;
            this.props.search.name = "";
            this.props.search.status = null;
            this.list();
        },
        siteList: function () {
            this.loading.isActive = true;
            this.$store.dispatch('site/lists').then(res => {
                this.site_default_outlet = res.data.data.site_default_outlet;
                this.loading.isActive = false;
            }).catch((err) => {
                this.loading.isActive = false;
            });
        },
        list: function (page = 1) {
            this.loading.isActive = true;
            this.props.search.page = page;
            return this.$store.dispatch("outlet/lists", this.props.search).then((res) => {
                this.loading.isActive = false;
            }).catch((err) => {
                this.loading.isActive = false;
            });
        },
        edit: function (outlet) {
            appService.modalShow();
            this.loading.isActive = true;
            this.$store.dispatch("outlet/edit", outlet.id);
            this.props.form = {
                name: outlet.name,
                email: outlet.email,
                country_code: outlet.country_code,
                phone: outlet.phone,
                latitude: outlet.latitude,
                longitude: outlet.longitude,
                city: outlet.city,
                state: outlet.state,
                zip_code: outlet.zip_code,
                address: outlet.address,
                status: outlet.status,
            };
            this.loading.isActive = false;
        },
        destroy: function (id) {
            appService
                .destroyConfirmation()
                .then((res) => {
                    try {
                        this.loading.isActive = true;
                        this.$store
                            .dispatch("outlet/destroy", {
                                id: id,
                                search: this.props.search,
                            })
                            .then((res) => {
                                this.loading.isActive = false;
                                alertService.successFlip(null, this.$t("menu.outlets"));
                            })
                            .catch((err) => {
                                this.loading.isActive = false;
                                alertService.error(err.response.data.message);
                            });
                    } catch (err) {
                        this.loading.isActive = false;
                        alertService.error(err.response.data.message);
                    }
                })
                .catch((err) => {
                    this.loading.isActive = false;
                });
        },
    },
};
</script>
